import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";

export function AdminGuard({ children }: { children: ReactNode }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Lädt …
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md text-center space-y-3">
          <h1 className="font-display text-2xl uppercase">Kein Zugriff</h1>
          <p className="text-sm text-muted-foreground">
            Dein Account existiert, hat aber noch keine Admin-Rolle. Teile mir kurz im Lovable-Chat
            deine E-Mail-Adresse mit, dann weise ich sie zu.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
